"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdeRequisitionDtoToJSON = exports.AdeRequisitionDtoFromJSONTyped = exports.AdeRequisitionDtoFromJSON = exports.instanceOfAdeRequisitionDto = exports.AdeRequisitionDtoStatusEnum = exports.AdeRequisitionDtoSpecialTypesEnum = exports.AdeRequisitionDtoSourceEnum = exports.AdeRequisitionDtoParentTypeEnum = exports.AdeRequisitionDtoOrderTypeEnum = exports.AdeRequisitionDtoPaymentStatusEnum = void 0;
var runtime_1 = require("../runtime");
var AdeCarrierCouplesConsent_1 = require("./AdeCarrierCouplesConsent");
var AdeInstitutionBillingDto_1 = require("./AdeInstitutionBillingDto");
var AdeInsuranceBillingDto_1 = require("./AdeInsuranceBillingDto");
var AdeReflexDetailsDto_1 = require("./AdeReflexDetailsDto");
var AdeRequisitionDtoPractice_1 = require("./AdeRequisitionDtoPractice");
var AdeRequisitionDtoRiskData_1 = require("./AdeRequisitionDtoRiskData");
var ClinicalTeamDto_1 = require("./ClinicalTeamDto");
var PatientDto_1 = require("./PatientDto");
var ReasonsForTestingDto_1 = require("./ReasonsForTestingDto");
var Reqrepov3PatientDto_1 = require("./Reqrepov3PatientDto");
var RequisitionAttachmentResponseDto_1 = require("./RequisitionAttachmentResponseDto");
var RequisitionConceptResponseDto_1 = require("./RequisitionConceptResponseDto");
var RequisitionPricingDto_1 = require("./RequisitionPricingDto");
var RequisitionSpecimenWithLabelDto_1 = require("./RequisitionSpecimenWithLabelDto");
/**
 * @export
 */
exports.AdeRequisitionDtoPaymentStatusEnum = {
    Complete: 'complete',
    Pending: 'pending',
    Empty: ''
};
/**
 * @export
 */
exports.AdeRequisitionDtoOrderTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
/**
 * @export
 */
exports.AdeRequisitionDtoParentTypeEnum = {
    DemoteToDuoRemoveFather: 'demote_to_duo_remove_father',
    DemoteToDuoRemoveMother: 'demote_to_duo_remove_mother',
    DemoteToProbandOnly: 'demote_to_proband_only',
    PreventiveReport: 'preventive_report',
    Rereq: 'rereq',
    Rerun: 'rerun',
    Switch: 'switch',
    Upgrade: 'upgrade',
    Empty: ''
};
/**
 * @export
 */
exports.AdeRequisitionDtoSourceEnum = {
    Api: 'api',
    Backoffice: 'backoffice',
    Cgc: 'cgc',
    ClinicHub: 'clinic_hub',
    Emr: 'emr',
    Fht: 'fht',
    PatientInitiated: 'patient_initiated',
    PatientShare: 'patient_share',
    Portal: 'portal',
    PortalBouncer: 'portal-bouncer',
    Unspecified: 'unspecified'
};
/**
 * @export
 */
exports.AdeRequisitionDtoSpecialTypesEnum = {
    FetalSample: 'fetal_sample',
    FvtExternal: 'fvt_external',
    FvtExternalWithPositiveControl: 'fvt_external_with_positive_control',
    FvtInternal: 'fvt_internal',
    FvtOnly: 'fvt_only',
    FvtWithAdditionalGenes: 'fvt_with_additional_genes',
    FvtWithFullGene: 'fvt_with_full_gene',
    HematologicMalignancy: 'hematologic_malignancy',
    Other: 'other',
    PositiveControl: 'positive_control',
    Reflex: 'reflex',
    TestOfRelatedSamples: 'test_of_related_samples',
    TestOfRelatedSamplesNeedsJointAnalysis: 'test_of_related_samples_needs_joint_analysis',
    Tp53VariantProgram: 'tp53_variant_program',
    VusRecommended: 'vus_recommended',
    VusResolution: 'vus_resolution'
};
/**
 * @export
 */
exports.AdeRequisitionDtoStatusEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    PreCropHold: 'PRE_CROP_HOLD',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    PostCropHold: 'POST_CROP_HOLD',
    ReportReleased: 'REPORT_RELEASED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the AdeRequisitionDto interface.
 */
function instanceOfAdeRequisitionDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdeRequisitionDto = instanceOfAdeRequisitionDto;
function AdeRequisitionDtoFromJSON(json) {
    return AdeRequisitionDtoFromJSONTyped(json, false);
}
exports.AdeRequisitionDtoFromJSON = AdeRequisitionDtoFromJSON;
function AdeRequisitionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessionDate': !(0, runtime_1.exists)(json, 'accessionDate') ? undefined : json['accessionDate'],
        'addedGenesIds': !(0, runtime_1.exists)(json, 'addedGenesIds') ? undefined : json['addedGenesIds'],
        'attachments': !(0, runtime_1.exists)(json, 'attachments') ? undefined : (json['attachments'].map(RequisitionAttachmentResponseDto_1.RequisitionAttachmentResponseDtoFromJSON)),
        'clinicalArea': !(0, runtime_1.exists)(json, 'clinicalArea') ? undefined : json['clinicalArea'],
        'clinicalFollowUp': !(0, runtime_1.exists)(json, 'clinicalFollowUp') ? undefined : json['clinicalFollowUp'],
        'collectionDate': !(0, runtime_1.exists)(json, 'collectionDate') ? undefined : json['collectionDate'],
        'concepts': !(0, runtime_1.exists)(json, 'concepts') ? undefined : (json['concepts'].map(RequisitionConceptResponseDto_1.RequisitionConceptResponseDtoFromJSON)),
        'icd10Codes': !(0, runtime_1.exists)(json, 'icd10Codes') ? undefined : json['icd10Codes'],
        'insuranceBilling': !(0, runtime_1.exists)(json, 'insuranceBilling') ? undefined : (json['insuranceBilling'].map(AdeInsuranceBillingDto_1.AdeInsuranceBillingDtoFromJSON)),
        'institutionBilling': !(0, runtime_1.exists)(json, 'institutionBilling') ? undefined : (0, AdeInstitutionBillingDto_1.AdeInstitutionBillingDtoFromJSON)(json['institutionBilling']),
        'billingEmail': !(0, runtime_1.exists)(json, 'billingEmail') ? undefined : json['billingEmail'],
        'billingPhone': !(0, runtime_1.exists)(json, 'billingPhone') ? undefined : json['billingPhone'],
        'paymentStatus': !(0, runtime_1.exists)(json, 'paymentStatus') ? undefined : json['paymentStatus'],
        'invitaeStudyCode': !(0, runtime_1.exists)(json, 'invitaeStudyCode') ? undefined : json['invitaeStudyCode'],
        'practice': !(0, runtime_1.exists)(json, 'practice') ? undefined : (0, AdeRequisitionDtoPractice_1.AdeRequisitionDtoPracticeFromJSON)(json['practice']),
        'orderType': !(0, runtime_1.exists)(json, 'orderType') ? undefined : json['orderType'],
        'parentReqid': !(0, runtime_1.exists)(json, 'parentReqid') ? undefined : json['parentReqid'],
        'parentType': !(0, runtime_1.exists)(json, 'parentType') ? undefined : json['parentType'],
        'patientSpecimens': !(0, runtime_1.exists)(json, 'patientSpecimens') ? undefined : json['patientSpecimens'],
        'paymentType': !(0, runtime_1.exists)(json, 'paymentType') ? undefined : json['paymentType'],
        'physicianSignDate': !(0, runtime_1.exists)(json, 'physicianSignDate') ? undefined : json['physicianSignDate'],
        'reflexDetails': !(0, runtime_1.exists)(json, 'reflexDetails') ? undefined : (0, AdeReflexDetailsDto_1.AdeReflexDetailsDtoFromJSON)(json['reflexDetails']),
        'rereqSet': !(0, runtime_1.exists)(json, 'rereqSet') ? undefined : json['rereqSet'],
        'rrsLocked': !(0, runtime_1.exists)(json, 'rrsLocked') ? undefined : json['rrsLocked'],
        'reviewedAt': !(0, runtime_1.exists)(json, 'reviewedAt') ? undefined : json['reviewedAt'],
        'riskData': !(0, runtime_1.exists)(json, 'riskData') ? undefined : (0, AdeRequisitionDtoRiskData_1.AdeRequisitionDtoRiskDataFromJSON)(json['riskData']),
        'salesforceLink': !(0, runtime_1.exists)(json, 'salesforceLink') ? undefined : json['salesforceLink'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : json['source'],
        'specialTypes': !(0, runtime_1.exists)(json, 'specialTypes') ? undefined : json['specialTypes'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'patients': !(0, runtime_1.exists)(json, 'patients') ? undefined : (json['patients'].map(Reqrepov3PatientDto_1.Reqrepov3PatientDtoFromJSON)),
        'patient': !(0, runtime_1.exists)(json, 'patient') ? undefined : (0, PatientDto_1.PatientDtoFromJSON)(json['patient']),
        'mother': !(0, runtime_1.exists)(json, 'mother') ? undefined : (0, PatientDto_1.PatientDtoFromJSON)(json['mother']),
        'father': !(0, runtime_1.exists)(json, 'father') ? undefined : (0, PatientDto_1.PatientDtoFromJSON)(json['father']),
        'pricing': !(0, runtime_1.exists)(json, 'pricing') ? undefined : (0, RequisitionPricingDto_1.RequisitionPricingDtoFromJSON)(json['pricing']),
        'reasonsForTesting': !(0, runtime_1.exists)(json, 'reasonsForTesting') ? undefined : (0, ReasonsForTestingDto_1.ReasonsForTestingDtoFromJSON)(json['reasonsForTesting']),
        'clinicalTeam': !(0, runtime_1.exists)(json, 'clinicalTeam') ? undefined : (0, ClinicalTeamDto_1.ClinicalTeamDtoFromJSON)(json['clinicalTeam']),
        'specimensAndLabels': !(0, runtime_1.exists)(json, 'specimensAndLabels') ? undefined : (json['specimensAndLabels'].map(RequisitionSpecimenWithLabelDto_1.RequisitionSpecimenWithLabelDtoFromJSON)),
        'labLocation': !(0, runtime_1.exists)(json, 'labLocation') ? undefined : json['labLocation'],
        'isVerificationOnly': !(0, runtime_1.exists)(json, 'isVerificationOnly') ? undefined : json['isVerificationOnly'],
        'carrierCouplesConsents': !(0, runtime_1.exists)(json, 'carrierCouplesConsents') ? undefined : (json['carrierCouplesConsents'] === null ? null : json['carrierCouplesConsents'].map(AdeCarrierCouplesConsent_1.AdeCarrierCouplesConsentFromJSON)),
    };
}
exports.AdeRequisitionDtoFromJSONTyped = AdeRequisitionDtoFromJSONTyped;
function AdeRequisitionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessionDate': value.accessionDate,
        'addedGenesIds': value.addedGenesIds,
        'attachments': value.attachments === undefined ? undefined : (value.attachments.map(RequisitionAttachmentResponseDto_1.RequisitionAttachmentResponseDtoToJSON)),
        'clinicalArea': value.clinicalArea,
        'clinicalFollowUp': value.clinicalFollowUp,
        'collectionDate': value.collectionDate,
        'concepts': value.concepts === undefined ? undefined : (value.concepts.map(RequisitionConceptResponseDto_1.RequisitionConceptResponseDtoToJSON)),
        'icd10Codes': value.icd10Codes,
        'insuranceBilling': value.insuranceBilling === undefined ? undefined : (value.insuranceBilling.map(AdeInsuranceBillingDto_1.AdeInsuranceBillingDtoToJSON)),
        'institutionBilling': (0, AdeInstitutionBillingDto_1.AdeInstitutionBillingDtoToJSON)(value.institutionBilling),
        'billingEmail': value.billingEmail,
        'billingPhone': value.billingPhone,
        'paymentStatus': value.paymentStatus,
        'invitaeStudyCode': value.invitaeStudyCode,
        'practice': (0, AdeRequisitionDtoPractice_1.AdeRequisitionDtoPracticeToJSON)(value.practice),
        'orderType': value.orderType,
        'parentReqid': value.parentReqid,
        'parentType': value.parentType,
        'patientSpecimens': value.patientSpecimens,
        'paymentType': value.paymentType,
        'physicianSignDate': value.physicianSignDate,
        'reflexDetails': (0, AdeReflexDetailsDto_1.AdeReflexDetailsDtoToJSON)(value.reflexDetails),
        'rereqSet': value.rereqSet,
        'rrsLocked': value.rrsLocked,
        'reviewedAt': value.reviewedAt,
        'riskData': (0, AdeRequisitionDtoRiskData_1.AdeRequisitionDtoRiskDataToJSON)(value.riskData),
        'salesforceLink': value.salesforceLink,
        'source': value.source,
        'specialTypes': value.specialTypes,
        'status': value.status,
        'patients': value.patients === undefined ? undefined : (value.patients.map(Reqrepov3PatientDto_1.Reqrepov3PatientDtoToJSON)),
        'patient': (0, PatientDto_1.PatientDtoToJSON)(value.patient),
        'mother': (0, PatientDto_1.PatientDtoToJSON)(value.mother),
        'father': (0, PatientDto_1.PatientDtoToJSON)(value.father),
        'pricing': (0, RequisitionPricingDto_1.RequisitionPricingDtoToJSON)(value.pricing),
        'reasonsForTesting': (0, ReasonsForTestingDto_1.ReasonsForTestingDtoToJSON)(value.reasonsForTesting),
        'clinicalTeam': (0, ClinicalTeamDto_1.ClinicalTeamDtoToJSON)(value.clinicalTeam),
        'specimensAndLabels': value.specimensAndLabels === undefined ? undefined : (value.specimensAndLabels.map(RequisitionSpecimenWithLabelDto_1.RequisitionSpecimenWithLabelDtoToJSON)),
        'labLocation': value.labLocation,
        'isVerificationOnly': value.isVerificationOnly,
        'carrierCouplesConsents': value.carrierCouplesConsents === undefined ? undefined : (value.carrierCouplesConsents === null ? null : value.carrierCouplesConsents.map(AdeCarrierCouplesConsent_1.AdeCarrierCouplesConsentToJSON)),
    };
}
exports.AdeRequisitionDtoToJSON = AdeRequisitionDtoToJSON;
